module.exports = "/packs/images/homepage/activity/extreme_retina~f205d93233a72fbae46028121391be0a.jpg";